"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _noop = _interopRequireDefault(require("lodash/noop"));
var _useInvalidateRefdata = _interopRequireDefault(require("../useInvalidateRefdata"));
var _useMutateGeneric = _interopRequireDefault(require("../useMutateGeneric"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const useMutateRefdataCategory = _ref => {
  let {
    afterQueryCalls: {
      delete: afterQueryDelete = _noop.default,
      post: afterQueryPost = _noop.default,
      put: afterQueryPut = _noop.default
    } = {},
    endpoint,
    ...mutateGenericProps
  } = _ref;
  const invalidateRefdata = (0, _useInvalidateRefdata.default)();
  return (0, _useMutateGeneric.default)({
    afterQueryCalls: {
      delete: res => {
        invalidateRefdata().then(() => {
          afterQueryDelete(res);
        });
      },
      post: res => {
        invalidateRefdata().then(() => {
          afterQueryPost(res);
        });
      },
      put: res => {
        invalidateRefdata().then(() => {
          afterQueryPut(res);
        });
      }
    },
    endpoint,
    payloadMutators: {
      post: data => ({
        json: {
          ...data,
          values: []
        }
      })
    },
    queryKey: ['stripes-kint-components', 'useMutateRefdataCategory'],
    ...mutateGenericProps
  });
};
var _default = exports.default = useMutateRefdataCategory;